import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";

function handleLogin(instance) {
    instance.loginRedirect(loginRequest).catch(e => {
        console.error(e);
    });
}


export const LoginButton = () => {

    const { instance } = useMsal();

    return (
        <div className={'loginSubmit actionButton'} onClick={() => handleLogin(instance)}>Login with Microsoft</div>
    );
}